export enum CodeInputsSettings {
  MAX_CODE_INPUT = 5,
}
